import moment from 'moment';
import { formModes, juniorSalesConsultantPosition } from '../../../constants.js';

export default {
    updateFields(documentData, context) {
        const { formMode } = context;

        const nowDate = new Date();

        if (formMode !== formModes.read) {
            const dateField = documentData.form.fields.find(f => f.name === 'sx:trTransferDate');

            const dateValue = moment(nowDate);
            let addedDays = 0;

            while (addedDays < 3) {
                dateValue.add(1, 'day');

                const dayOfWeek = dateValue.day();

                if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                    addedDays++;
                }
            }
            dateField.minValue = moment(dateValue).format("YYYY-MM-DD");
        }
        const scheduleField = documentData.form.fields.find(f => f.name === 'sx:trSchedule');
        scheduleField.visible = documentData.properties['sx:frToOffice'] === juniorSalesConsultantPosition;
    },

    checkInputPage(documentData, context) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        const { formMode } = context;

        if (formMode === formModes.create) {
            if (!documentData.properties["sx:trSubordinate"]) {
                result = false;
                errorElementName = "sx:trSubordinate";
            }
        }
        else {
            if (!documentData.properties["assoc:sx:trSubordinate_added"]) {
                result = false;
                errorElementName = "assoc:sx:trSubordinate_added";
            }
        }
        if (result && !documentData.properties["sx:frRegion"]) {
            result = false;
            errorElementName = "sx:frRegion";
        }
        if (result && !documentData.properties["sx:frPhoneNumber"]) {
            result = false;
            errorElementName = "sx:frPhoneNumber";
        }
        if (result && !documentData.properties["sx:trFromStore"]) {
            result = false;
            errorElementName = "sx:trFromStore";
        }
        if (result && !documentData.properties["sx:frFromOffice"]) {
            result = false;
            errorElementName = "sx:frFromOffice";
        }
        if (result && !documentData.properties["sx:frTTFrom"]) {
            result = false;
            errorElementName = "sx:frTTFrom";
        }
        if (result && !documentData.properties["sx:trFromRate"]) {
            result = false;
            errorElementName = "sx:trFromRate";
        }
        if (result && !documentData.properties["sx:trToStore"]) {
            result = false;
            errorElementName = "sx:trToStore";
        }
        if (result && !documentData.properties["sx:frToOffice"]) {
            result = false;
            errorElementName = "sx:frToOffice";
        }
        if (result && !documentData.properties["sx:frTTTO"]) {
            result = false;
            errorElementName = "sx:frTTTO";
        }
        if (result && !documentData.properties["sx:trToRate"]) {
            result = false;
            errorElementName = "sx:trToRate";
        }
        if (result && !documentData.properties["sx:trTransferDate"]) {
            result = false;
            errorElementName = "sx:trTransferDate";
        }
        if (result && documentData.properties["sx:frToOffice"] === juniorSalesConsultantPosition && !documentData.properties["sx:trSchedule"]) {
            result = false;
            errorElementName = "sx:trSchedule";
        }

        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}